import Service from "../service"

const Auth = {
    login(data) {
        return Service.post("/auth/login", data)
    },
    register(data){
        return Service.post('/auth/register',data);
    },
    update(id, data) {
        return Service.post("/update/" + id, data);
    },
    getUserAll() {
        return Service.get("/get_user");
    },
};

export default Auth;
